import { render, staticRenderFns } from "./ImageZipPreview.vue?vue&type=template&id=33380d3f&"
import script from "./ImageZipPreview.vue?vue&type=script&lang=ts&"
export * from "./ImageZipPreview.vue?vue&type=script&lang=ts&"
import style0 from "./ImageZipPreview.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports